var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2119",
    "data-name": "Rectangle 2119",
    width: 19,
    height: 19,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9951",
    "data-name": "Path 9951",
    d: "M0,9.54c.33-.25.6-.55.9-.82.57-.52,1.12-1,1.68-1.57.11-.11.16-.09.26,0,1.27,1.36,2.55,2.72,3.82,4.09.11.12.17.12.29,0L9.49,8.9a.32.32,0,0,1,.06.25v4.56a.64.64,0,0,1,0,.2l-2.8,2.6c-.09.09-.14.09-.23,0L1.26,10.9,0,9.57Z",
    fill: "#89da53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9952",
    "data-name": "Path 9952",
    d: "M9.53,13.91c-.06-.06,0-.14,0-.21V8.9l1.3-1.21,3.34-3.1,2.22-2.07c.12-.11.17-.08.26,0,.77.85,1.56,1.7,2.34,2.55h0l-1.5,1.38-7.43,6.89Z",
    fill: "#5dc177"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChecked);
export default __webpack_public_path__ + "static/media/ic_checked.9592403cb31ae0a9b052548e132ddbb6.svg";
export { ForwardRef as ReactComponent };